import React, { useRef, useState } from 'react';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button';
import Customer2 from './wizard_pages/customer_pages2/Customer2';
import ErgaCat2 from './wizard_pages/erga_cat_pages2/ErgaCat2';
import Erga2 from './wizard_pages/erga_pages2/Erga2';
import Paradotea2 from './wizard_pages/paradotea_pages2/Paradotea2';
import Timologia2 from './wizard_pages/timologia_pages2/Timologia2';
import Ekxorimena_Timologia2 from './wizard_pages/ekxwrimeno_timologio_pages2/Ekxorimena_Timologia2';
import Layout from './Layout';

const Stepper_Esoda1 = () => {
    const stepperRef = useRef(null);
    // const [refresh, setRefresh] = useState(false);

    // const handleAddTagClick = () => {
    //     setRefresh(prev => !prev); // Toggle state to force a re-render
    // };

    return (
        <Layout>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
            <Stepper 
                ref={stepperRef} 
                style={{ flex: '1', display: 'flex', flexDirection: 'column', width: '100%' }}
            >
                <StepperPanel header="Customer" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <div 
                            style={{ 
                                border: '2px dashed #ccc', 
                                borderRadius: '0.25rem', 
                                flex: '1', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                fontWeight: '500' 
                            }}
                        >
                            <Customer2 />
                        </div>
                        {/* <div 
                            style={{ 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                marginTop: '2rem', 
                                padding: '1rem', 
                                width: '100%' 
                            }}
                        >
                            <AddTag2 onButtonClick={handleAddTagClick} />
                        </div> */}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1rem' }}>
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                    </div>
                </StepperPanel>
                <StepperPanel header="Erga" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <div 
                            style={{ 
                                border: '2px dashed #ccc', 
                                borderRadius: '0.25rem', 
                                flex: '1', 
                                display: 'block', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                fontWeight: '500' ,
                                width: '100%',
                                height: '1500px'
                            }}
                        >
                            <div style={{ marginBottom: '1rem', width: '100%' }}>
                                    <Erga2 />
                                </div>
                                <div style={{ marginTop: '1rem', width: '100%' }}>
                                    <ErgaCat2 />
                                </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '1rem' }}>
                        <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                    </div>
                </StepperPanel>
                <StepperPanel header="Paradotea" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <div 
                            style={{ 
                                border: '2px dashed #ccc', 
                                borderRadius: '0.25rem', 
                                flex: '1', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                fontWeight: '500',
                                width: '1500px'
                            }}
                        >
                            <Paradotea2></Paradotea2>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '1rem' }}>
                        <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                    </div>
                </StepperPanel>

                <StepperPanel header="Timologia" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <div 
                            style={{ 
                                border: '2px dashed #ccc', 
                                borderRadius: '0.25rem', 
                                flex: '1', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                fontWeight: '500'
                            }}
                        >
                            <Timologia2></Timologia2>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '1rem' }}>
                        <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                        <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                    </div>
                </StepperPanel>
                <StepperPanel header="Ekxorimena Timologia" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <div 
                            style={{ 
                                border: '2px dashed #ccc', 
                                borderRadius: '0.25rem', 
                                flex: '1', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                fontWeight: '500'
                            }}
                        >
                            <Ekxorimena_Timologia2></Ekxorimena_Timologia2>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', paddingTop: '1rem' }}>
                        <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                    </div>
                </StepperPanel>
            </Stepper>
        </div>
        </Layout>
    );

    
};

export default Stepper_Esoda1;